import { CssBaseline } from "@mui/material";
import { StyledEngineProvider } from "@mui/styled-engine";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import App from "./App";
import i18n from "./i18n";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import bugCapture from "./bug-capture";

bugCapture.init({
  app: "WEB_ORDERING",
  apiBase: process.env.REACT_APP_API_URL || "",
  reportPath: "/web/bug-report",
  getToken: () => null,
  appVersion: process.env.REACT_APP_VERSION || null,
});

window.addEventListener("error", (event) => {
  bugCapture.report({ tier: "A", kind: "JS_ERROR", message: event.error?.message || event.message, stack: event.error?.stack || null, fileLine: event.filename ? `${event.filename}:${event.lineno}:${event.colno}` : null }).catch(() => {});
});

window.addEventListener("unhandledrejection", (event) => {
  const err = event.reason;
  bugCapture.report({ tier: "A", kind: "UNHANDLED_REJECTION", message: err?.message || String(err), stack: err?.stack || null }).catch(() => {});
});

const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <StyledEngineProvider injectFirst>
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <CssBaseline />
        <App />
      </BrowserRouter>
    </I18nextProvider>
  </StyledEngineProvider>
);
reportWebVitals();
